import { useEffect, useState } from "react";
import { NavLink, Outlet, Navigate, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth, hasRole } from "../lib/store";

const MENU = [
  ["Übersicht", "/admin", ["george", "artist", "venue_manager"]],
  ["Startseiten & ChatGPT", "/admin/startseiten", []],
  ["Georges Startseite", "/admin/george-start", []],
  ["Mayas Startseite", "/admin/maya-start", []],
  ["Martins Startseite", "/admin/martin-start", []],
  ["Pilot-Feedback", "/admin/pilot-rueckmeldungen", []],
  ["Loris Startseite", "/admin/lori-start", []],
  ["Joachims Startseite", "/admin/joachim-start", []],
  ["Anfragen", "/admin/anfragen", ["george"]],
  ["Lokal-Auswahl", "/admin/lokal-auswahl", ["venue_partner", "artist", "george", "venue_manager"]],
  ["Druckanfragen", "/admin/druckanfragen", ["artist"]],
  ["Editionen", "/admin/editionen", ["artist", "production"]],
  ["Mein Werk teilen", "/admin/teilen", ["artist"]],
  ["Lokal vorschlagen", "/admin/lokalvorschlaege", ["artist", "george"]],
  ["Aufbau & Content", "/admin/content", ["george", "venue_manager"]],
  ["Konditionen", "/admin/konditionen", ["artist"]],
  ["Mein Paket / Testphase", "/admin/paket", ["artist"]],
  ["Promotionspakete", "/admin/promotionspakete", ["artist", "editor"]],
  ["Promotionliste", "/admin/promotion", ["editor", "george"]],
  ["Bestellungen", "/admin/bestellungen", []],
  ["Druckaufträge", "/admin/druck", ["production"]],
  ["Hero", "/admin/hero", ["editor"]],
  ["Werke & Prints", "/admin/e/artworks", ["editor", "george", "artist", "venue_manager"]],
  ["Künstler", "/admin/e/artists", ["editor", "george", "artist"]],
  ["Lokale", "/admin/e/venues", ["editor", "george", "venue_manager"]],
  ["Platzierungen", "/admin/e/placements", ["george", "venue_manager"]],
  ["QR-Codes", "/admin/qr", ["george", "venue_manager"]],
  ["Vernissagen", "/admin/e/events", ["editor", "george"]],
  ["Fundstücke", "/admin/e/finds", ["george", "editor"]],
  ["Einrichtung", "/admin/e/interior_services", ["george"]],
  ["Über uns", "/admin/e/team_profiles", ["editor"]],
  ["Seiten & Recht", "/admin/e/pages", ["editor"]],
  ["Kunden", "/admin/e/customers", []],
  ["Pakete", "/admin/e/packages", []],
  ["Mitgliedschaften", "/admin/mitgliedschaften", ["artist"]],
  ["Rechtefreigaben", "/admin/e/rights", ["artist"]],
  ["Leistungsnachweise", "/admin/e/proofs", ["editor", "artist"]],
  ["Abrechnung", "/admin/abrechnung", ["artist"]],
  ["René & George", "/admin/aufteilung", ["george"]],
  ["Gemeinsame Kosten", "/admin/e/shared_costs", ["george"]],
  ["Promotionsangebote", "/admin/e/promo_offers", []],
  ["Externe Listings", "/admin/e/external_listings", ["editor"]],
  ["Social-Studio", "/admin/social", ["editor", "george"]],
  ["Socialmaterial", "/admin/e/social_assets", ["editor", "george"]],
  ["Nutzer & Rollen", "/admin/nutzer", []],
  ["E-Mail-Postausgang", "/admin/mail", []],
  ["Einstellungen", "/admin/einstellungen", []],
  ["Daten & Protokoll", "/admin/daten", []],
  ["Mein Profil", "/admin/profil", ["george", "editor", "venue_manager", "artist", "production", "venue_partner"]],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [advanced, setAdvanced] = useState(false);
  useEffect(() => {
    document.title = "Verwaltung – Kunst und Fund";
  }, []);
  if (user === null) return <p className="p-10">Lädt …</p>;
  if (user === false) return <Navigate to="/login" replace />;
  const owner = user.roles?.includes("owner");
  const full = advanced || location.pathname === "/admin/gesamt";
  const pilotMenu = new Set(["/admin", "/admin/startseiten", "/admin/maya-start", "/admin/joachim-start", "/admin/e/artworks", "/admin/anfragen", "/admin/e/venues", "/admin/e/placements", "/admin/qr", "/admin/george-start", "/admin/lori-start", "/admin/martin-start", "/admin/pilot-rueckmeldungen", "/admin/profil"]);
  const person = user.workspace_person;
  const personalMenu = ["maya", "lori", "martin"].includes(person) ? new Set(["/admin", "/admin/e/artists", "/admin/e/artworks", "/admin/lokalvorschlaege", "/admin/teilen", "/admin/profil"]) : person === "joachim" ? new Set(["/admin", "/admin/e/venues", "/admin/content", "/admin/profil"]) : null;
  const georgeOnly = user.roles?.includes("george") && !user.roles.includes("owner");
  const menu = MENU.filter(([, , roles]) => hasRole(user, ...roles));
  const simple = new Set(["/admin", "/admin/e/finds", "/admin/e/interior_services", "/admin/anfragen", "/admin/e/venues", "/admin/lokalvorschlaege", "/admin/content", "/admin/profil"]);
  const navItem = ([label, to]) => <NavLink key={to} to={owner && full && to === "/admin" ? "/admin/gesamt" : to} end={to === "/admin"} className={({ isActive }) => `px-3 py-2.5 whitespace-nowrap ${isActive ? "bg-[#FAF8F5] text-[#121212] font-semibold" : "hover:bg-white/10"}`} data-testid={`admin-nav-${to.split("/").pop()}`}>{(georgeOnly || personalMenu) && to === "/admin" ? "Mein Start" : label}</NavLink>;
  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[250px_1fr] bg-[#FAF8F5]" data-testid="admin-layout">
      <aside className="bg-[#121212] text-[#FAF8F5] lg:min-h-screen lg:sticky lg:top-0 lg:h-screen overflow-y-auto no-print">
        <div className="p-5 border-b border-white/10">
          <Link to="/" className="font-display font-black text-xl">Kunst <span className="text-[#FF5A5F]">&</span> Fund</Link>
          <p className="text-xs text-[#9b968e] mt-1" data-testid="admin-user">{user.name} · {user.roles.join(", ")}</p>
        </div>
        <nav className="p-2 flex lg:flex-col gap-1 overflow-x-auto text-sm" aria-label="Verwaltung">
          {owner && <div className="flex lg:flex-col gap-1 mb-2" aria-label="Verwaltungsansicht"><button type="button" onClick={() => { setAdvanced(false); navigate("/admin"); }} className={`px-3 py-3 text-left font-bold whitespace-nowrap ${!full ? "bg-[#FF5A5F] text-[#121212]" : "border border-white/30"}`}>Probebetrieb</button><button type="button" onClick={() => { setAdvanced(true); navigate("/admin/gesamt"); }} className={`px-3 py-3 text-left font-bold whitespace-nowrap ${full ? "bg-[#FF5A5F] text-[#121212]" : "border border-white/30"}`}>Gesamtverwaltung</button></div>}
          {(!owner && personalMenu ? menu.filter(([, to]) => personalMenu.has(to)) : georgeOnly ? menu.filter(([, to]) => simple.has(to)) : owner && !full ? menu.filter(([, to]) => pilotMenu.has(to)) : menu).map(navItem)}
          {georgeOnly && <details className="px-1"><summary className="cursor-pointer px-2 py-2.5 whitespace-nowrap">Weitere Werkzeuge</summary><div className="flex flex-col gap-1">{menu.filter(([, to]) => !simple.has(to)).map(navItem)}</div></details>}
          {!owner && user.roles?.includes("artist") && <Link to={["lori", "martin"].includes(person) ? "/admin#pilot-feedback" : "/kontakt"} className="px-3 py-2.5 text-[#FFC72C] font-semibold whitespace-nowrap" data-testid="artist-feedback">Feedback / Problem melden</Link>}
          <button onClick={logout} className="px-3 py-2.5 text-left text-[#FF5A5F] whitespace-nowrap" data-testid="admin-logout">Abmelden</button>
        </nav>
      </aside>
      <main className="p-4 sm:p-8 min-w-0"><Outlet /></main>
    </div>
  );
}




